import { observer } from 'mobx-react-lite'
import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import type { RemoveBusinessDialogViewModel } from './RemoveBusinessDialogViewModel'

export { RemoveBusinessDialogViewModel } from './RemoveBusinessDialogViewModel'

interface RemoveBusinessDialogProps {
  vm: RemoveBusinessDialogViewModel
  testId?: string
}

export const RemoveBusinessDialog = observer(function RemoveBusinessDialog({
  vm,
  testId,
}: RemoveBusinessDialogProps) {
  return (
    <ModalDialog
      isOpen={vm.modal.showing}
      onClose={vm.closeDialog}
      isDismissable
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>
          Remove info about {vm.businessName}?
        </ModalDialogTitle>
        <ModalDialogDescription>
          This will remove the business from this tax preparation. This action
          cannot be undone.
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter sticky bordered compact>
        <ModalDialogActions>
          <Button
            label="Yes, delete"
            variant="destructive"
            onPress={vm.confirm}
            testId={testId ? `${testId}-confirm-button` : undefined}
          />
          <Button
            variant="outline"
            label="Cancel"
            onPress={vm.closeDialog}
            testId={testId ? `${testId}-cancel-button` : undefined}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
})
